import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const support = {
  fetchSupportMeta: lazyModuleMethod(
    () => import('./fetchSupportMeta'),
    'default'
  ),
  postFormToSupport: lazyModuleMethod(
    () => import('./postFormToSupport'),
    'default'
  ),
}
